import { Box, Tab, Tabs } from "@mui/material";
import useCustomTabs from "shared/hooks/useCustomTabs";
import UploadJsonForm from "./UploadJsonForm";
import ManualCreateForm from "./ManualCreateForm";
import { GroupCertificationModalContextProvider } from "../hooks/useGroupCertifModal";
import CreateAssociatedGroupCertificationModal from "./CreateAssociatedGroupCertificationModal";

type SiteCreateTab = "manual" | "JSON";

export const SiteCreate = () => {
  const { value, handleChange } = useCustomTabs<SiteCreateTab>({ initialValue: "manual" });

  return (
    <GroupCertificationModalContextProvider>
      <Box sx={{ width: "100%", bgcolor: "background.paper" }}>
        <Tabs value={value} onChange={handleChange} centered>
          <Tab label="Manual" value="manual" />
          <Tab label="Upload JSON" value="JSON" />
        </Tabs>
        {value === "manual" && <ManualCreateForm />}
        {value === "JSON" && <UploadJsonForm />}
        <CreateAssociatedGroupCertificationModal />
      </Box>
    </GroupCertificationModalContextProvider>
  );
};
